export default "__VITE_ASSET__ee20d1f4__"